import React from "react";
import P2PDuelMatchup from "../../p2p/floor/P2PDuelMatchup";
import { predictionFixtureDuel, predictionTimingBadge } from "../../users/userPredictionHelpers";

function timingTone(tone) {
  return tone === "live" ? "live" : tone === "warn" ? "warn" : "muted";
}

export default function PredictionsFixtureBlock({
  prediction,
  as = "span",
  compact = false,
  scalableLogos = false,
  logoSize,
  className = "",
  showTimingBadge = true,
  showPremiumBadge = false,
}) {
  const timing = predictionTimingBadge(prediction.timing);
  const tone = timing ? timingTone(timing.tone) : "muted";

  return (
    <div className={`apr-fixture-block${className ? ` ${className}` : ""}`}>
      <div className="apr-fixture-line">
        <P2PDuelMatchup
          duel={predictionFixtureDuel(prediction)}
          as={as}
          compact={compact}
          showLogos
          alignLeft
          scalableLogos={scalableLogos}
          logoSize={logoSize}
        />
        {showTimingBadge && timing ? (
          <span className={`amf-row-tag amf-row-tag-${tone} apr-fixture-timing-badge`}>
            {timing.label}
          </span>
        ) : null}
        {showPremiumBadge && prediction.isPremium ? (
          <span className="amf-row-tag amf-row-tag-warn apr-fixture-premium-badge">Premium</span>
        ) : null}
      </div>
    </div>
  );
}
